import type { IconData } from '@stacksjs/iconify-core'

export const entertainmentEventsHobbiesVideoMovieProducerDirectorChair: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M29 12.2v3h-3.1v1.6H29v3h1.5v-6.1H32v-1.5zm-.1 7.6h-1.5v1.5h1.5zM27.4 3h-1.5v9.1h1.5zM4.6 21.3v1.6h3v1.5h1.5v-1.5h13.7v1.5h1.6v-1.5h3v-1.6zm19.7 9.2h-3V32h3z\"/><path fill=\"currentColor\" d=\"M22.8 24.4h-3v1.5h3zm-1.4 4.5h-3.1v1.5h3.1zm-4.6-3v1.5h-1.6v-1.5h-3v1.5h1.5v1.5h4.6v-1.5h1.5v-1.5zm-3.1-15.2h1.5V9.1h1.6v1.6h1.5V7.6h1.5V6.1h-3V4.6h-1.6v1.5h-3v1.5h1.5zm.1 18.2h-3.1v1.5h3.1zm-1.7-4.5h-3v1.5h3zm-1.5 6.1h-3V32h3zM25.9 3V1.5h-3.1V0h-1.5v1.5H10.7V0H9.1v1.5h-3V3zm0 15.3v-1.5h-3v-3h3v-1.5H6.1v1.5h3.1v3H6.1v1.5zm-15.2-4.6h10.7v3H10.7zM6.1 3H4.6v9.1h1.5zM4.5 19.8H3v1.5h1.5zm-1.5-3h3.1v-1.6H3v-3H0v1.5h1.5v6.1H3z\"/>",
  "width": 32,
  "height": 32,
  "viewBox": "0 0 32 32"
}

export default entertainmentEventsHobbiesVideoMovieProducerDirectorChair
